import React, { useState } from 'react';
import { API } from '../../Services/api';

const API_BASE = process.env.REACT_APP_API_CONNECT;

const MusicContainer = ({ data }) => {
    const [error, setError] = useState("");
    const [deletePreloader, setDeletePreloader] = useState(false);

    const deleteMusic = async (musicId) => {
        try {
            setDeletePreloader(true);
            await API.deleteMusic(musicId);
            window.location.reload();
        } catch (error) {
            console.error("Error in deleting music: ", error);
            setError(`${error.status}, ${error}`);
        } finally {
            setDeletePreloader(false);
        }
    };

    return (
        <div id={`music-${data.id}`} className="in-list-track-box">
            <div className="main-track-box">
                <img className="cover-track-box" src={`${API_BASE}/uploads/music/${data.cover_path}`} />
                <div className="another-info-track-in-box">
                    <p className="title-track-box">{data.title}</p>
                    <p className="author-track-box">{data.author}</p>
                    <audio controls className="audio-track-box"><source src={`${API_BASE}/uploads/music/${data.audio_path}`} id="src" /></audio>
                </div>
                {!deletePreloader ? (
                    <button onClick={(e) => {deleteMusic(data.id)}} className="button-delete-track">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 7V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                ) : (
                    <div className="custom-loader-spinner white" />
                )}
            </div>
            <p className="error-in-track">{error}</p>
        </div>
    );
};

export default MusicContainer;